import React, { useEffect } from 'react';
import Animated from 'components/generals/AnimatedComponent';
import ContactInfoForm from 'components/generals/forms/info';
export default function Home__section__16() {
    return (
        <main className="nv__section nv__section--no-margin nv__hp__section__16">
            <section className="nv__section__container">
                <Animated animation={'animate__fadeInDown animate__delay-1s'}>
                    <p className="paragraph">
                        Para aquellos con una visión audaz y un deseo de hacer una diferencia real
                        en el mundo, <strong>ROOTSTOKEN</strong> ofrece una oportunidad sin
                        precedentes. Únete a una comunidad de líderes financieros y ambientales y
                        haz historia mientras aseguras tu propio legado de prosperidad.
                    </p>
                </Animated>

                {/* <Animated animation={'animate__fadeInDown animate__delay-2s'}>
                    <p className="paragraph paragraph--green">
                        Lorem ipsum dolor sit amet consectetur, adipisicing elit. Consequuntur illo
                        rem repellat quia animi eligendi illum.
                    </p>
                </Animated>

                <Animated animation={'animate__fadeInDown animate__delay-3s'}>
                    <h3>¡Lorem ipsum dolor sit amet consectetur, adipisicing elit.!</h3>
                </Animated> */}
            </section>
        </main>
    );
}
